export enum LofinoDataTypes {
    float = 'float',
    boolean = 'boolean',
    string = 'string',
    date = 'date',
    text = 'text',
    header = 'header',
    space = 'space',
}
